import moment from 'moment';
import CRUDgeneric from 'utils/CRUDgeneric';
import { formatReceived } from 'utils/formatValues';

// Defino a donde el cliente consumira los enpoints.
const _cliente = CRUDgeneric('/nominas/configurar-guardias-vacacionales/');
// El nombre del modelo que aparecera al agregar y editar.
const _nameModel = 'Periodo en Guardia Vacacional';
// El nombre del modelo para mencionar al nombre del registro.
const _nameModelSingular = 'el Periodo de Guardia Vacacional';

// Formatea el registro antes insertarlo al form.
const _formatRecordForRead = (record) => {
  const dataFormatedById = {
    ...formatReceived(record),
    periodos_vacacionales: record?.periodos_vacacionales?.id ?? record?.periodos_vacacionales,
    fecha_inicial: record?.fecha_inicial
      ? moment(record?.fecha_inicial)
      : null,
    fecha_final: record?.fecha_final
      ? moment(record?.fecha_final)
      : null,
    fecha_inicio_registro: record?.fecha_inicio_registro
      ? moment(record?.fecha_inicio_registro)
      : null,
    fecha_final_registro: record?.fecha_final_registro
      ? moment(record?.fecha_final_registro)
      : null,
    fecha_de_cierre: record?.fecha_de_cierre
      ? moment(record?.fecha_de_cierre)
      : null,
    fecha_inicial_vigencia_vacaciones: record?.fecha_inicial_vigencia_vacaciones
      ? moment(record?.fecha_inicial_vigencia_vacaciones)
      : null,
    fecha_final_vigencia_vacaciones: record?.fecha_final_vigencia_vacaciones
      ? moment(record?.fecha_final_vigencia_vacaciones)
      : null,
    estados_globales: record?.estados_globales?.id,
    configurar_guardias_vacacionales_general: record?.configurar_guardias_vacacionales_general?.id,
  };
  return dataFormatedById;
};
// Formatea el registro antes de enviarlo al backend.
/** necesario en fechas, de lo contrario solo volver a mandar el record */
const _formatRecordForSend = (record) => {
  const _record = record;
  if (record.fecha_inicial?.format) {
    _record.fecha_inicial = record.fecha_inicial.format('YYYY-MM-DD');
  }
  if (record.fecha_final?.format) {
    _record.fecha_final = record.fecha_final.format('YYYY-MM-DD');
  }
  if (record.fecha_inicio_registro?.format) {
    _record.fecha_inicio_registro = record.fecha_inicio_registro.format('YYYY-MM-DD');
  }
  if (record.fecha_final_registro?.format) {
    _record.fecha_final_registro = record.fecha_final_registro.format('YYYY-MM-DD');
  }
  if (record.fecha_de_cierre?.format) {
    _record.fecha_de_cierre = record.fecha_de_cierre.format('YYYY-MM-DD');
  }
  if (record.fecha_inicial_vigencia_vacaciones?.format) {
    _record.fecha_inicial_vigencia_vacaciones = record.fecha_inicial_vigencia_vacaciones.format('YYYY-MM-DD');
  }
  if (record.fecha_final_vigencia_vacaciones?.format) {
    _record.fecha_final_vigencia_vacaciones = record.fecha_final_vigencia_vacaciones.format('YYYY-MM-DD');
  }
  return _record;
};

// Empaqueto todo en un objeto
/** permite llamarlo facilmente por el editor */
export const ModelInfoConfigGuardVacaPeriodos = {
  cliente: _cliente,
  nameModel: _nameModel,
  nameModelSingular: _nameModelSingular,
  formatter: { // el actor que formatea.
    formatRecordForRead: _formatRecordForRead,
    formatRecordForSend: _formatRecordForSend,
  },
};

/**
 * GET Guardias Vacacionales Periodos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getGuardiasVacacionalesPeriodos = async (params) => (
  _cliente.obtenerListaDeRegistros(params)
);

export const calcularDiasHabiles = (inicio, fin) => {
  if (!inicio || !fin) return 0;

  const start = inicio.startOf('day');
  const end = fin.startOf('day');

  if (end.isBefore(start)) return 0;

  let dias = 0;
  let current = start.clone();

  while (current.isSameOrBefore(end)) {
    const day = current.day(); // 0=Sunday, 6=Saturday
    if (day > 0 && day < 6) {
      dias += 1;
    }
    current = current.add(1, 'day');
  }

  return dias;
};
